import React from "react";
import { SUB_DIRCTORY } from "../../../app_config";

const ParkingLocationGateSettingsRoutes = [
  {
    path: `${SUB_DIRCTORY}/parkingLocationGateSettings/:action/:id?`,
    component: React.lazy(() => import("./addParkingLocationGateSettings")),
  },
  {
    path: `${SUB_DIRCTORY}/parkingLocationGateSettings`,
    component: React.lazy(() => import("./parkingLocationGateSettings")),
  },
];

export default ParkingLocationGateSettingsRoutes;